import axios from "axios";

const LeaveAllocationService = {
  // Allocation rows of one employee (all years)
  async getByEmployee(serviceNo) {
    try {
      const response = await axios.get(
        `/EmpLeaveAllocation/GetEmpLeaveAllocation?p_empServiceNo=${encodeURIComponent(serviceNo)}`
      );
      console.log("[LeaveAllocation] getByEmployee response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveAllocation] Error fetching allocation:", error);
      throw error;
    }
  },

  // Type-wise totals for every employee
  async getSummary() {
    try {
      const response = await axios.get("/EmpLeaveAllocation/GetEmpLeaveSummery");
      console.log("[LeaveAllocation] getSummary response:", response.data);
      return response.data;
    } catch (error) {
      console.error("[LeaveAllocation] Error fetching summary:", error);
      throw error;
    }
  },
};

export default LeaveAllocationService;